import { Component } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { AdvancedSearchItem } from '../../models/domain/advanced.search.item';
import { AdvancedSearchResultMemberItem, AdvancedSearchResultLicenseItem } from '../../models/domain/advanced.searche.results';
import { TrainingEventSubscription, SubscriptionMethodTypes } from '../../models/domain/training.event.subscription';
import { LicenseStatusTypes } from '../../models/domain/license';
import { Router } from '@angular/router';

export interface IAddAttendeeDialogModel {
    title: string;
    Products: Array<number>;
}

@Component({
    selector: 'add-attendee-dialog',
    styleUrls: ['./add.attendee.dialog.css'],
    templateUrl: './add.attendee.dialog.html'
})

export class AddAttendeeDialog extends DialogComponent<IAddAttendeeDialogModel, TrainingEventSubscription> implements IAddAttendeeDialogModel {
    IsBusy: Boolean = false;
    title: string;
    Products: Array<number>;

    searchQuery: string;
    searchResponse: Array<AdvancedSearchResultMemberItem> = new Array<AdvancedSearchResultMemberItem>();
    searched: Boolean = false;
    activeMember: number;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, public router: Router) {
        super(dialogService, router);
    }

    searchForMember() {
        this.searched = false;
        this.IsBusy = true;
        this.activeMember = null;
        let query = new AdvancedSearchItem();
        query.SmartSearch = this.searchQuery;
        query.IncludeDesignerLicenses = true;
        query.Status = [LicenseStatusTypes.Open, LicenseStatusTypes.Registered];
        let disposable = this.api.SearchAdvanced(query).subscribe(response => {
            this.searched = true;
            this.IsBusy = false;
            disposable.unsubscribe();
            this.searchResponse = response.Data.Data.filter(item => item.License && item.License.Status <= 1 && item.License.IsAssigned && this.Products.indexOf(item.License.ProductID) >= 0);
        })
    }

    isMemberActive(member) {
        if (member.ID == this.activeMember) {
            return true;
        } else {
            return false;
        }
    }

    selectLicense(member: AdvancedSearchResultMemberItem, license: AdvancedSearchResultLicenseItem) {
        let result = new TrainingEventSubscription();
        result.License_ID = license.LicenseID;
        result.LicenseKey = license.Key;
        result.Member_ID = member.ID;
        result.MemberEmail = member.Email;
        result.MemberName = license.DesignerName;
        result.MemberPhone = member.Phone1;
        result.SubscriptionMethodType = SubscriptionMethodTypes.Admin;
        result.SubscriptionNotes = '';
        result.Original_Product_ID = license.ProductID;
        result.Original_ProductName = license.ProductName;
        result.SoftwareVersion = license.Version;

        this.result = result;
        this.close();
    }

    confirm() {
        // this.result = new TrainingEventSubscription();
        this.close();
    }

}
